import styled from '@emotion/styled'
import { WebLink } from '@news-mono/web-common'
import { colors } from '../../__styling/settings/colors'
import { metrics } from '../../__styling/settings/metrics'
import { breakpoint } from '../../__styling/style-functions'
import { calcRem } from '../../__styling/style-functions/calc-rem'
import { IconChevronRightTN } from '../../icons/IconChevronRightTN/IconChevronRightTN'
import { fonts } from '../../__styling'

export const StyledSiteMapWrapper = styled('div')({
    padding: calcRem(0, metrics.thenightly.margins.m2l),
    maxWidth: calcRem(770),
    margin: '0 auto',
    fontFamily: fonts.thenightly.sansSerif,
    [breakpoint('sm')]: {
        padding: calcRem(0, metrics.thenightly.margins.lg),
    },

    [breakpoint('mlg')]: {
        padding: 0,
    },
})

export const StyledSiteMapHeader = styled('h1')({
    fontSize: calcRem(32),
    lineHeight: '120%',
    fontWeight: 600,
    letterSpacing: calcRem(-0.03),
    margin: calcRem(0, 0, metrics.thenightly.margins.m2l),

    [breakpoint('sm')]: {
        fontSize: calcRem(36),
        lineHeight: calcRem(40),
    },

    [breakpoint('mlg')]: {
        fontSize: calcRem(40),
        lineHeight: calcRem(48),
        marginBottom: calcRem(metrics.thenightly.margins.xxxl),
    },
})

export const StyledHeaderLink = styled(WebLink)({
    color: 'inherit',
    textDecoration: 'none',
})

export const StyledYearList = styled('ul')({
    padding: 0,
    margin: 0,
    listStyle: 'none',
})

export const StyledYearIndex = styled('li')({
    backgroundColor: colors.thenightly.neutral[10],
    listStyle: 'none',
    display: 'flex',
    flexDirection: 'column',
    gap: calcRem(metrics.thenightly.margins.m2l),
    padding: calcRem(metrics.thenightly.margins.m2l),
    '& + &': {
        marginTop: calcRem(metrics.thenightly.margins.md),
    },
    [breakpoint('sm')]: {
        flexDirection: 'row',
        gap: calcRem(metrics.thenightly.margins.xxxl),
    },
})

export const StyledYear = styled('div')({
    fontSize: calcRem(20),
    lineHeight: calcRem(24),
    fontWeight: 700,
    letterSpacing: calcRem(-0.02),
    color: colors.thenightly.neutral[100],

    [breakpoint('sm')]: {
        fontSize: calcRem(22),
        lineHeight: calcRem(32),
    },

    [breakpoint('mlg')]: {
        fontSize: calcRem(25),
    },
})

export const StyledMonths = styled('ul')({
    padding: 0,
    margin: 0,
    listStyle: 'none',
    display: 'flex',
    flexWrap: 'wrap',
    columnGap: calcRem(metrics.thenightly.margins.m2l),
    rowGap: calcRem(metrics.thenightly.margins.sm2l),
    [breakpoint('mlg')]: {
        flex: 1,
        minWidth: 0,
        maxWidth: `calc(${calcRem(120 * 4)} + ${calcRem(
            metrics.thenightly.margins.m2l * 3,
        )})`,
    },
})

export const StyledMonth = styled('li')({
    padding: 0,
    margin: 0,
    width: calcRem(120),
    maxWidth: calcRem(120),
    flexShrink: 0,
})

export const StyledMonthLink = styled(WebLink)({
    fontWeight: 600,
    lineHeight: '125%',
    letterSpacing: calcRem(-0.02),
    textDecoration: 'none',
    color: colors.thenightly.neutral[80],

    [breakpoint('sm')]: {
        fontSize: calcRem(18),
        lineHeight: calcRem(24),
    },

    [breakpoint('mlg')]: {
        fontSize: calcRem(20),
        lineHeight: calcRem(28),
    },
})

export const StyledSiteMapBreadcrumb = styled('div')({
    display: 'flex',
    alignItems: 'center',
    marginBottom: calcRem(metrics.thenightly.margins.m2l),
    [breakpoint('mlg')]: {
        marginBottom: calcRem(metrics.thenightly.margins.xxxl),
    },
})

export const StyledChevron = styled(IconChevronRightTN)({
    width: calcRem(24),
    height: calcRem(24),
    display: 'flex',
    color: colors.thenightly.neutral[40],
})
export const StyledBreadcrumbLink = styled(WebLink)({
    textDecoration: 'none',
    color: colors.thenightly.neutral[100],
    fontWeight: 700,
    lineHeight: calcRem(24),
    letterSpacing: calcRem(-0.02),
    fontSize: calcRem(20),
    margin: calcRem(0, metrics.thenightly.margins.xs),

    [breakpoint('sm')]: {
        fontSize: calcRem(22),
        lineHeight: calcRem(32),
    },

    [breakpoint('mlg')]: {
        fontSize: calcRem(25),
        lineHeight: calcRem(32),
    },
})

export const StyledSiteMapDayList = styled('ul')({
    display: 'flex',
    listStyle: 'none',
    padding: 0,
    margin: 0,
    gap: calcRem(metrics.thenightly.margins.sm),
    flexWrap: 'wrap',

    marginBottom: calcRem(metrics.thenightly.margins.m2l),
    [breakpoint('mlg')]: {
        marginBottom: calcRem(metrics.thenightly.margins.xxxl),
    },
})

export const StyledSiteMapDay = styled('li')<{ isActive?: boolean }>(
    ({ isActive }) => ({
        padding: 0,
        margin: 0,
        color: colors.thenightly.neutral[isActive ? 10 : 100],
    }),
)

export const StyledDayLink = styled(WebLink)({
    width: calcRem(40),
    height: calcRem(40),
    fontWeight: 400,
    fontSize: calcRem(20),
    lineHeight: calcRem(24),
    letterSpacing: calcRem(-0.02),
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: colors.thenightly.neutral[100],
    backgroundColor: colors.thenightly.neutral[10],

    [breakpoint('sm')]: {
        fontSize: calcRem(18),
        lineHeight: calcRem(24),
    },

    [breakpoint('mlg')]: {
        fontSize: calcRem(20),
        lineHeight: calcRem(28),
    },
})

export const StyledDayText = styled('div')({
    width: calcRem(40),
    height: calcRem(40),
    fontWeight: 400,
    fontSize: calcRem(20),
    lineHeight: calcRem(24),
    letterSpacing: calcRem(-0.02),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: colors.thenightly.neutral[10],
    backgroundColor: colors.thenightly.neutral[100],

    [breakpoint('sm')]: {
        fontSize: calcRem(18),
        lineHeight: calcRem(24),
    },

    [breakpoint('mlg')]: {
        fontSize: calcRem(20),
        lineHeight: calcRem(28),
    },
})

/** Article list */
export const StyledPublicationList = styled('ul')({
    display: 'flex',
    flexDirection: 'column',
    listStyle: 'none',
    padding: 0,
    margin: 0,
})

export const StyledPublication = styled('li')({
    margin: 0,
    borderBottom: `1px solid ${colors.thenightly.neutral[40]}`,
    padding: calcRem(metrics.thenightly.margins.md, 0),
})

export const StyledPublicationLink = styled(WebLink)({
    textDecoration: 'none',
    color: colors.thenightly.neutral[100],
    fontWeight: 600,
    lineHeight: '125%',
    letterSpacing: calcRem(-0.02),
    fontSize: calcRem(16),
})
